// Everything editable about the CNA training section lives here.

// Web3Forms access key (create one at web3forms.com using rogart409@gmail.com).
// Submissions are emailed to the address the key was created with.
export const WEB3FORMS_KEY = 'ee5b07ed-c560-4fc3-9bd2-4635421acd94';

export const SCHOOL_NAME = 'Regni CNA Program';

// Course details. Any value left as null is hidden on the site.
export const COURSE_DETAILS = [
  { label: 'Program length', value: null },
  { label: 'Schedule', value: null },
  { label: 'Location', value: null },
  { label: 'Tuition', value: null },
];

export const HIGHLIGHTS = [
  {
    title: 'Hands-on learning',
    text: 'Practice real patient-care skills with guidance, so you feel confident on your first day on the job.',
  },
  {
    title: 'State board prep & review',
    text: 'Focused review for the CNA certification exam, covering both the written test and the skills evaluation.',
  },
  {
    title: 'A rewarding career',
    text: 'Nursing care is meaningful, in-demand work that makes a difference in people’s lives every day.',
  },
  {
    title: 'Join the team of caregivers',
    text: 'Become part of the healthcare team in hospitals, doctors’ offices and nursing homes.',
  },
];

export const JOURNEY = [
  { step: 'Enroll', text: 'Leave your info and we will follow up with you.' },
  { step: 'Train', text: 'Hands-on learning with an experienced nurse.' },
  { step: 'Review', text: 'Prepare for the state board exam.' },
  { step: 'Certified', text: 'Start your healthcare career as a CNA.' },
];
